import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

function mapStateToProps(state) {
   return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  }
}

class Links extends Component {

  render() {

    return (
      <div className="Links">

        <div className="Links__shows">
          <h2>Upcoming Shows</h2>
          <h3>July 4, 2021 - Blue Moon Tavern - Seattle, WA</h3>
          
        </div>


      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Links);



// WEBPACK FOOTER //
// ./src/views/Links/Links.js